const canVerifyInformationsGuard = {
  beforeEnter: (to, from, next) => {
    if (Laravel.user.has_verified_his_informations) {
      return next({ path: "/" });
    }

    next();
  }
};

export { canVerifyInformationsGuard };
